<template>
  <slot :modalName="modalName" :isShown="isModalShown" />
</template>

<script setup lang="ts">
import { ref, computed, provide } from 'vue'

interface RichTextModal {
  register: (name: string) => void
  unregister: () => void
  isModalShown: boolean
}

const emit = defineEmits<{
  (event: 'modalchange', modalName: string | null): void
}>()

const modalName = ref<string | null>(null)
const isModalShown = computed(() => !!modalName.value)

// Register/unregister functions
const register = (name: string): void => {
  modalName.value = name
  emit('modalchange', name)
}

const unregister = (): void => {
  modalName.value = null
  emit('modalchange', null)
}

const provided: RichTextModal = {
  register,
  unregister,
  isModalShown: isModalShown.value
}

provide('richTextModal', provided)
</script>
